import Vue from 'vue'
// 入口文件
import App from './App.vue'
// 路由配置信息
import router from './router'
import '@babel/polyfill'
// import 'babel/polyfill'
import vueResource from 'vue-resource'
import store from '../../store/index'
// bootstrap样式
// import 'bootstrap/dist/css/bootstrap.min.css'
import '../../plugins/element/element.js'
import commonjs from '../../plugins/common/index'
// 全局配置信息
import '../../resource/global'
//公用样式
import './assets/css/site.css'
//主题样式
import './assets/css/theme.css'
import './assets/css/theme-red.css'
//百度地图
import BaiduMap from 'vue-baidu-map'
//国际化
import i18n from '../../i18n/i18n'
//引入自定义全局模板
// import ataHeader from '@components/header'
import ataSideBar from '@components/sidebar'
import mianBao from '@components/mainbao'
import ataFooter from '@components/footer'
//读取错误编码表
import '../../resource/zh-cn.js'
// 使用 (http) 功能
Vue.use(vueResource);
// 使用自定义全局模板
// Vue.use(ataHeader);
Vue.use(ataSideBar);
Vue.use(mianBao);
// 页脚组件
Vue.use(ataFooter);
// 公用脚本
Vue.use(commonjs);
// import pinyin from 'pinyin'
// Vue.use(pinyin)
Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'm4cbEs4Hm0LkveuAbNBGO9eS8Kbx7YvL'
})
Vue.config.productionTip = false
let home = store.state.examInfo.currentExamInfo.batchCode?'batch_main':'main';
router.beforeEach((to, from, next) => {
    // 根据路由meta信息设置页面title
    typeof to.meta.pageTitle !== undefined && globalProvider.setDocumentTitle(to.meta.pageTitle);
    if (to.matched.some(record => record.meta.requiresAuth || record.meta.requiresAuth == null)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (store.state.common.token == null) {
            if (to.name == 'default_moreAnnoucement') {
                next();
            } else if (store.state.examInfo.currentExamInfo == null) {
                next({
                    name: 'default.notFound'
                });
            } else {
                next({
                    name:home,
                    params: {
                        projectCode: store.state.examInfo.currentExamInfo.domain,
                        batchCode:store.state.examInfo.currentExamInfo.batchCode
                    },
                    query: {
                        redirect: to.fullPath
                    }
                })
            }
        } else {
            if (to.matched.some(record => record.meta.projectPage)) {
                next()
            } else {
                next()
            }
        }
    } else {
        if (to.name != 'main' && to.name != 'batch_main' && to.name != 'default.notFound' && to.name != 'default_examReg_payBack' && to.name != 'asset_index' && store.state.examInfo.currentExamInfo == null&& to.name != 'default_order_beikeReservation'&& to.name != 'default.dynotice' && to.name != 'default_examReg_payBack' && to.name != 'default.noticePage' && to.name != 'default.dyIndex') {
            next({
                name: 'default.notFound'
            });
        } else {
            next() // 确保一定要调用 next()
        }
    }
});
/*全局捕获http请求,需要放在初始化之前，不然不能使用*/

Vue.http.interceptors.push(function (request, next) {
    //考生登录情况下添加token
    request.params.timeCode = new Date().getTime();
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
        //ie
        request.params.timeCode = new Date().getTime();
    }
    if (request.url.indexOf(serviceUrl) >= 0) {
        request.headers.set(AUTH_APP_KEY_SCHEME, APIKey);
        if (store.state.common.token != null) {
            if(store.state.common.token.split(" ")[0]=="Bearer"){
                request.headers.set('Authorization',  this.$store.state.common.token);
            }else  if(store.state.common.token){
                request.headers.set('Authorization', AUTH_TOKEN_SCHEME + ' ' + this.$store.state.common.token);
            }
        }
    }

    // 请求开始时，弹出loading加载层
    var loadingInstance;
    if (request.params.loading == true) {
        request.before = function (req) {
            loadingInstance = this.$loading({
                fullscreen: true,
                text: '正在加载中...'
            });
        }
    }

    // 请求结束时，自定义处理之前，关闭loading加载层
    next((response) => {
        if (request.params.loading == true) {
            loadingInstance.close();
        }
        if (!response.ok) {
            if (response.status === 401) {
                store.commit('removeCurrentUser');
                this.$router.push({
                    name: home,
                    params: {
                        projectCode: store.state.examInfo.currentExamInfo.domain,
                        batchCode:store.state.examInfo.currentExamInfo.batchCode
                    }
                });
            } else if (response.status === 404) {
                this.$alert('网络繁忙，请稍后再试！', '提示信息', {
                    confirmButtonText: '确定',
                    callback: action => {
                        this.$router.push({
                            name:home,
                            params: {
                                projectCode: store.state.examInfo.currentExamInfo.domain,
                                batchCode:store.state.examInfo.currentExamInfo.batchCode
                            }
                        });
                    }
                });
            } else {
                this.$alert('网络繁忙，请稍后再试！', '提示信息', {
                    confirmButtonText: '确定',
                    callback: action => {}
                });
            }
        }
        if (response.body.code != null && response.body.code != undefined) {
            if (response.body.code == resultCode.ErrorException) {
                this.$alert("抱歉，系统发生错误（错误代码：" + response.body.message + "）请尝试刷新页面或点击右下角联系客服", '提示', {
                    confirmButtonText: '确定',
                    dangerouslyUseHTMLString: true
                })
            }
        }
        return response;
    });
});
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')